import React from 'react'

import { Image } from 'lib/components'

export default function CertifiedIcon(props: any) {
  return (
    <Image
      alt="Certified Badge"
      src="/images/trustedApps/certifiedBadge.svg"
      {...props}
    />
  )
}
